import { CDN_PATH } from './constants';
import { LanguageType } from '../types';

export const getAudioUrl = (language: LanguageType, audioName: string) =>
  `${CDN_PATH}${language}/${audioName}`;
